import { Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import theme from "styles/theme";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      px={2}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, mb: 2, color: `${theme.palette.primary.main}` }} />

      <Typography
        variant="h2"
        component="h1"
        fontWeight="bold"
        gutterBottom
        sx={{
          "@media (max-width:480px)": {
            fontSize: "2.6rem",
          },
        }}
      >
        Página não encontrada
      </Typography>

      <Typography
        variant="h5"
        component="h2"
        fontWeight="normal"
        color={theme.custom.light.textColor}
        mb={4}
        sx={{
          "@media (max-width:480px)": {
            fontSize: "1.1rem",
          },
        }}
      >
        O link acessado pode estar incorreto ou a página foi removida.
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate("/")}
        sx={{ borderRadius: "999px", px: 4, py: 1 }}
      >
        Voltar para o início
      </Button>
    </Box>
  );
}
